{
  "chapel": {
    "u0": -16,
    "chordU": 17.5,
    "vc": -20,
    "half": 4.2,
    "eaveY": 12,
    "ridgeY": 17.7,
    "apse": "flat"
  },
  "belfry": {
    "u": 9,
    "v": -20,
    "radius": 0.45,
    "foot": 15.7,
    "eaves": 17.7,
    "tip": 22.5
  },
  "ranges": [
    {
      "id": "north-spoey-wing",
      "u": -4.53,
      "v": 12.42,
      "angleDeg": 4.5,
      "length": 51.6,
      "width": 8.5,
      "eaves": 11.2,
      "ridge": 17,
      "floors": 3,
      "bays": 11,
      "roof": "slate",
      "passage": 0,
      "windowRows": [
        {
          "sill": 0.85,
          "top": 2.6,
          "width": 1.1
        },
        {
          "sill": 4.1,
          "top": 6.5,
          "width": 1.1
        },
        {
          "sill": 7.7,
          "top": 10.1,
          "width": 1.1
        }
      ],
      "roofGables": {
        "centres": [-24, -16, -8, 0, 8, 16, 24],
        "halfWidth": 0.8,
        "v0": 0.9,
        "v1": 4.25,
        "eaves": 15.9,
        "ridge": 17.2,
        "sill": 13.8,
        "top": 14.9
      }
    },
    {
      "id": "nes-wing",
      "u": -28.1,
      "v": -4.5,
      "angleDeg": 90,
      "length": 26,
      "width": 5.8,
      "eaves": 7.7,
      "ridge": 11.5,
      "floors": 2,
      "bays": 5,
      "roof": "tile",
      "passage": 0
    },
    {
      "id": "southern-west-wing",
      "u": -23.2,
      "v": -20,
      "angleDeg": 0,
      "length": 16,
      "width": 8.4,
      "eaves": 9.4,
      "ridge": 14.7,
      "floors": 3,
      "bays": 3,
      "roof": "slate",
      "passage": 0
    },
    {
      "id": "chapel-side-body",
      "u": 0,
      "v": -14.75,
      "angleDeg": 0,
      "length": 27,
      "width": 2,
      "eaves": 5,
      "ridge": 6.8,
      "floors": 1,
      "bays": 5,
      "roof": "slate",
      "passage": 0
    },
    {
      "id": "canal-side-house",
      "u": 15.7,
      "v": -13.4,
      "angleDeg": 0,
      "length": 10,
      "width": 4,
      "eaves": 8.2,
      "ridge": 11.3,
      "floors": 2,
      "bays": 2,
      "roof": "tile",
      "passage": 0
    },
    {
      "id": "canal-gate-wing",
      "u": 18.8,
      "v": 0.5,
      "angleDeg": 90,
      "length": 18,
      "width": 4.6,
      "eaves": 5.8,
      "ridge": 9,
      "floors": 2,
      "bays": 4,
      "roof": "tile",
      "passage": 3,
      "passageU": 1.5
    }
  ],
  "floors": [
    {
      "ring": [
        [-25.1, -13.3],
        [15.7, -13.3],
        [15.7, 5.8],
        [-25.1, 5.8]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-22.5, -11],
        [12.5, -11],
        [12.5, 3.5],
        [-22.5, 3.5]
      ],
      "height": 0.04,
      "garden": true
    },
    {
      "ring": [
        [-30.9, -28.5],
        [19.4, -28.5],
        [19.4, -24.3],
        [-30.9, -24.3]
      ],
      "height": 0.025,
      "garden": false
    }
  ],
  "walls": [
    {
      "to": [-30.95, -24.25],
      "width": 0.3,
      "height": 2.2,
      "from": [-30.95, -28.4]
    },
    {
      "to": [20.9, -8.5],
      "width": 0.3,
      "height": 2.2,
      "from": [20.9, -11.4]
    }
  ],
  "note": "Painting and 1544 woodcut guide the tall northern Spoey wing, west/south bodies, separate southern chapel, narrow parallel roof, canal house, lower frontage and open court. Burger and Pan’s 1998 fabric study identifies the surviving medieval north wing and the later replacement of its roof; its cross-section is hypothetical, not a measured 1538 elevation. Their study also warns that the 1760 view exaggerates the chapel side aisle. The small parallel body does not copy that oversized aisle. All lengths, widths, elevations, windows, bays, gablet counts, belfry, soil boundaries, access and hidden façades are fitted estimates. The southern path represents the shared private approach between Magdalena and Barbara; it is not Sint Barberenstraat or a public route through to the Nes. Gate positions, the division of that path and the precinct edge remain provisional. The 1550 turfpakhuis and later Stadsbank frontages and interior court houses are excluded. The north wing is a separate institutional body rather than generated house fill; detailed room uses are not recovered."
}
